<template>
  <section class="page">
    <div class="page__header">
      <h1 class="page__title">{{ $t('mpo.title') }}</h1>
    </div>

    <!-- Вкладки -->
    <div class="tabs">
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'setup' }"
        @click="activeTab = 'setup'"
      >
        {{ $t('mpo.tabs.setup') }}
      </button>
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'survey' }"
        @click="activeTab = 'survey'"
        :disabled="!currentSurvey"
      >
        {{ $t('mpo.tabs.survey') }}
      </button>
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'results' }"
        @click="activeTab = 'results'"
        :disabled="!currentResult"
      >
        {{ $t('mpo.tabs.results') }}
      </button>
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'history' }"
        @click="activeTab = 'history'"
      >
        {{ $t('mpo.tabs.history') }}
      </button>
    </div>

    <!-- TAB 1: Настройка опроса -->
    <StarChartSetup 
      v-if="activeTab === 'setup'"
      @survey-created="onSurveyCreated"
    />

    <!-- TAB 2: Проведение опроса -->
    <StarChartSurvey 
      v-if="activeTab === 'survey' && currentSurvey"
      :survey="currentSurvey"
      :result="currentResult"
      @survey-completed="onSurveyCompleted"
    />

    <!-- TAB 3: Результаты -->
    <StarChartResults 
      v-if="activeTab === 'results' && currentResult"
      :result="currentResult"
      :survey="currentSurvey"
    />

    <!-- TAB 4: История опросов -->
    <SurveyHistory 
      v-if="activeTab === 'history'"
      @survey-selected="onHistorySurveySelected"
    />
  </section>
</template>

<script>
import StarChartSetup from '@/views/mpo/components/StarChartSetup.vue'
import StarChartSurvey from '@/views/mpo/components/StarChartSurvey.vue'
import StarChartResults from '@/views/mpo/components/StarChartResults.vue'
import SurveyHistory from '@/views/mpo/components/SurveyHistory.vue'
import { getSurvey, getSurveyResult } from '@/api/mpo'

export default {
  name: 'MpoStarChartView',
  components: {
    StarChartSetup,
    StarChartSurvey,
    StarChartResults,
    SurveyHistory,
  },
  data() {
    return {
      activeTab: 'setup',
      currentSurvey: null,
      currentResult: null,
    }
  },
  mounted() {
    void this.restoreLastSurvey()
  },
  methods: {
    storageKey() {
      return 'mpo:lastSurveyId'
    },
    async restoreLastSurvey() {
      try {
        const raw = localStorage.getItem(this.storageKey())
        const id = raw ? parseInt(raw, 10) : NaN
        if (!Number.isFinite(id) || id <= 0) return

        const survey = await getSurvey(id)
        if (!survey) return

        this.currentSurvey = survey
        const result = await getSurveyResult(id)
        this.currentResult = result

        if (result) {
          this.activeTab = 'results'
        } else if (survey.status === 'in_progress') {
          this.activeTab = 'survey'
        }
      } catch (e) {
        console.error('MPO: restore failed', e)
      }
    },
    onSurveyCreated(survey) {
      this.currentSurvey = survey
      this.currentResult = null
      this.activeTab = 'survey'
      try { localStorage.setItem(this.storageKey(), String(survey?.id ?? '')) } catch { }
    },
    onSurveyCompleted(result) {
      this.currentResult = result
      this.activeTab = 'results'
    },
    onHistorySurveySelected(surveyData) {
      this.currentSurvey = surveyData.survey
      this.currentResult = surveyData.result
      this.activeTab = 'results'
      try { localStorage.setItem(this.storageKey(), String(surveyData?.survey?.id ?? '')) } catch { }
    },
  },
}
</script>

<style scoped>
.page {
  padding: 2rem;
  background: #f5f7fa;
  min-height: 100vh;
}

.page__header {
  margin-bottom: 2rem;
}

.page__title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
}

.tabs {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  border-bottom: 2px solid #e5e7eb;
}

.tab-btn {
  padding: 0.75rem 1.5rem;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 0.95rem;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tab-btn:hover:not(:disabled) {
  color: #1a202c;
}

.tab-btn.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
}

.tab-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>